import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const menuToggle = document.getElementById( 'menu-toggle' );

menuToggle.addEventListener( 'click', function() {
	const scrollable = document.querySelector( '.menu__items--primary' );
	const root       = document.getElementsByTagName( 'html' )[0];

	root.classList.toggle( 'has-active-menu' );

	if ( root.classList.contains ) {
		disableBodyScroll( scrollable );
	} else {
		enableBodyScroll( scrollable );
	}
} );

document.addEventListener( 'click', function( e ) {
	if ( e.target.classList.contains( 'menu__sub-menu-toggle' ) ) {
		const expanded = 'false' === e.target.getAttribute( 'aria-expanded' ) ? true : false;
		e.target.setAttribute( 'aria-expanded', expanded );
	}
} );
